const types = {
  SET_MODAL_STATUS: 'modal/CHANGE_MODAL_VISIBILITY_STATUS',
};

export default types;
